/**
 * Created by odrulea on 10/11/16.
 */
import FetchHelper from '../helpers/fetch_helper';

const HomeownerPortalDispatcher = {
  async fetchHomeownerStips(token) {
    token = token || this.getStoreVal('view').token; // use redux remove requirement for param
    if (!token) {
      return;
    }
    try {
      const homeownerCreditDocuments = (await FetchHelper.fetchJson(`homeowner/credit/${token}/?type=stip`))
        ?.results?.[0];
      this.setStoreValWithCheck('homeownerData', homeownerCreditDocuments);
      this.setStoreValWithCheck('customer', homeownerCreditDocuments.customer);
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: 'This link is not valid' },
      });
    }
  },
};

export default HomeownerPortalDispatcher;
